import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { ApiServices } from "services/apiServices";
import { Constants } from "services/keyConstants";
import { buildUrl, getItem } from "services/utils";

export const fetchData = createAsyncThunk("data/fetchData", async () => {
  try {
    let queryParams = {
      designationId: getItem(Constants.KEY_SELECTED_ROLE)?.roleId,
      clientUserId: getItem(Constants.KEY_USER_DATA)?._id,
    };
    const uri = buildUrl(`/master-doc-module/get-redux-data`, queryParams);
    let result = await ApiServices.callServiceGet(uri);
    console.log("result===>", result);
    if (result?.meta?.success) {
      return result?.data;
    } else {
      return {};
    }
  } catch (error) {
    console.error("Failed to load master data", errro);
  }
});

const dataSlice = createSlice({
  name: "data",
  initialState: {
    masterData: [],
    status: "",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchData.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchData.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.masterData = action.payload;
      })
      .addCase(fetchData.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export default dataSlice.reducer;
